<template lang="pug">
div
  section.u-mt-md
    AppTitle.u-mb-0(:title="$t('mantra')")


  section.u-mt-md
    .grid.is-tablet-6.is-widescreen-4
      .column.u-mb-sm(v-for="item,idx in $t('sec1Items')")
        h4 {{item.title}}
        p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec2')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec2Items')")
            h4 {{item.title}}
            p {{item.desc}}

  section.u-mt-md
    .grid
      .column.is-widescreen-5
        AppTitle.u-mb-mi(:title="$t('sec3')" tag="h2")
      .column.is-widescreen-7
        .grid.is-tablet-6
          .column.u-mb-sm(v-for="item,idx in $t('sec3Items')")
            h4 {{item.title}}
            p {{item.desc}}
            AppLink(v-if="item.url" :to="item.url" :title="$t('learnMore')" class="button-link is-small") {{$t('learnMore')}}

  section.u-mt-md.u-mb-md
    AppLink(to="/ordering" :title="$t('cta')" class="button-link is-large " v-html="$t('cta')")

</template>

<script>
export default {
  head() {
    const $t = this.$t.bind(this);
    return {
      title: $t('pageTitle'),
      meta: [
        {
          hid: 'og:title',
          name: 'og:title',
          property: 'og:title',
          content: $t('pageTitle')
        },
        {
          hid: 'description',
          name: 'description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:description',
          name: 'og:description',
          property: 'og:description',
          content: $t('pageDesc')
        },
        {
          hid: 'og:image',
          name: 'og:image',
          property: 'og:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        },
        {
          hid: 'twitter:image',
          name: 'twitter:image',
          property: 'twitter:image',
          content: 'https://cdn.baianat.com/static/share/services.png'
        }
      ]
    };
  }
};
</script>

<i18n>
{
  "en": {
    "pageTitle":"Manufacturing",
    "pageDesc":"Creating digital solutions to enhance your manufacturing processes and help you cope up with the rapid changing markets.",
    "mantra":"Smart factories |start now.",
    "sec1Items":{
      "1":{
        "title":"Maximize your output",
        "desc":"Gain real time visibility to your production process by combining the power of IoT and ERP."
      },
      "2":{
        "title":"Enhance your operations",
        "desc":"Improving your manauctuying quality, process, and materials through analytics and deep insights."
      },
      "3":{
        "title":"Optimize your supply chain",
        "desc":"Build a customer centric supply chain to come up with authentic production that satisfies your end customer needs."
      }
    },
    "sec2":"Innovation tailored for your factory",
    "sec2Items":{
      "1":{
        "title":"Web apps",
        "desc":"Creating a platform for your factory that showcases your manufacturing process, exporting distanciation and inside culture. "
      },
      "2":{
        "title":"Enterprise solutions ",
        "desc":"Supporting your business with ERP, CRM or human resources management systems tailored for your specific operations."
      }
    },
    "sec3":"Go global with your production.",
    "sec3Items":{
      "1":{
        "title":"Marketing",
        "desc":"Capitalizing on all the possible marketing channels to spread the word about your offerings and maximize your ROI",
        "url":"/services/marketing"
      },
      "2":{
        "title":"Growth",
        "desc":"Planning your exponential growth whether locally or globally and helping you to reach more interested buyer segments.",
        "url":"/services/growth"
      },
      "3":{
        "title":"Technology",
        "desc":"Using IoT, robotics and automation and AI to capitalize on your business data and get the best out of your workday.",
        "url":"/services/technology"
      }
    },
    "cta":"Autopilot your <br> factory."
  },
  "ar": {
    "pageTitle":"تصميم وبرمجة مواقع التصنيع",
    "pageDesc":"نعمل على إنشاء حلول رقمية لتعزيز عمليات التصنيع الخاصة بك ونساعدك على مواكبة الأسواق المتغيرة بسرعة ودعم عملياتك.",
    "mantra":"حلول مبتكرة لتصميم |وبرمجة مواقع التصنيع.",
    "sec1Items":{
      "1":{
        "title":"مضاعفة إنتاجيتك",
        "desc":"زود  من فرص  ظهورك  في الوقت الفعلي لعملية الإنتاج من خلال الجمع بين قوة إنترنت الأشياء IoT  وتخطيط موارد المؤسسات ERP."
      },
      "2":{
        "title":"تحسين عملياتك",
        "desc":"اعمل على تحسين الجودة ومعالجة المواد الخاصة بك وكذلك العمليات من خلال رؤى وتحليلات عميقة تساعدك على نمو أعمالك."
      },
      "3":{
        "title":"تحسين سلسلة التوريد الخاصة بك",
        "desc":"قم ببناء سلسلة التوريد التي تركز على العملاء من أجل التوصل إلى إنتاج حقيقي يلبي احتياجات العملاء ويحل مشكلاتهم."
      }
    },
    "sec2":"ابتكارات مصممة من أجل نجاح مصانعك.",
    "sec2Items":{
      "1":{
        "title":"تطبيقات الويب",
        "desc":"نعمل على إنشاء منصة لمصنعك والتي تعرض وتوضح العمليات التي تقوم بها داخل المصنع، وكذلك تظهر الثقافة التي يتميز بها مصنعك."
      },
      "2":{
        "title":"الحلول المؤسسية ",
        "desc":"ندعم عملك باستخدام أنظمة ادارة الموارد أو إدارة علاقات العملاء أو إدارة الموارد البشرية المصممة خصيصًا لعملياتك المحددة."
      }
    },
    "sec3":"اتجه نحو العالمية من خلال إنتاجك.",
    "sec3Items":{
      "1":{
        "title":"التسويق",
        "desc":"احصل على أقصى استفادة من جميع القنوات التسويقية التي يمكنك من خلالها نشر رسالتك حول المنتجات والعروض التي تقدمها.",
        "url":"/services/marketing"
      },
      "2":{
        "title":"استراتيجيات النمو",
        "desc":"خطط لنموك على نطاق أوسع سواء داخليًا أو خارجيًا. أوصل إلى الشرائح التي تتطابق مع ما تقدمه والتي تحتاج منتجك بشدة.",
        "url":"/services/growth"
      },
      "3":{
        "title":"التكنولوجيا",
        "desc":"استخدام إنترنت الأشياء والروبوتات والأتمتة والذكاء الاصطناعي للاستفادة من بيانات عملك واحصل على أقصى استفادة من عملياتك اليومية.",
        "url":"/services/technology"
      }
    },
    "cta":"درّْ عملك <br> بفاعلية تامة. "
  }
}
</i18n>
